module.exports = __webpack_public_path__ + "static/media/first_nft.bd03ce85.svg";